/* eslint-disable react/prop-types */
import React, {
  useCallback,
  useState,
  ReactNode,
  ElementType,
  MouseEvent,
} from "react";

interface WithModalProps {
  children?: ReactNode;
  modalProps?: any; // Replace with the actual type of your modal props
  altClick?: () => void;
  [key: string]: any;
}

const withModal =
  (Tag: ElementType, ModalTag: ElementType) =>
  ({ children, modalProps, altClick, ...props }: WithModalProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const toggle = useCallback(
      (event?: MouseEvent) => {
        if (event) {
          event.preventDefault();
        }
        setIsOpen(!isOpen);
      },
      [isOpen]
    );

    const handleClick = useCallback(
      (event: MouseEvent) => {
        console.log("event.ctrlKey", event.ctrlKey);
        // only prevent default if ctrl wasn't pressed
        if (altClick && event.ctrlKey) {
          return altClick();
        }

        event.preventDefault();
        return toggle();
      },
      [altClick, toggle]
    );

    return (
      <>
        <Tag {...props} onClick={handleClick}>
          {children}
        </Tag>
        <ModalTag
          isOpen={isOpen}
          toggle={toggle}
          setOpen={setIsOpen}
          {...modalProps}
        />
      </>
    );
  };

export default withModal;
